module.exports = __webpack_public_path__ + "static/img/case7.a4e32f9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Home/case7.png
// module id = TB+9
// module chunks = 1